import type { ErrorContext } from "@lib/errors";
import { BrazeServerSideError } from "@lib/errors";

function isWarnPayload(
  payload: any
  // eslint-disable-next-line camelcase
): payload is { warn: string; error_context: ErrorContext; message: string; name?: string } {
  return payload?.warn;
}

export async function extractResponseOrThrowBrazeServerSideError<T = unknown>(payload: T): Promise<T> {
  if (isWarnPayload(payload)) {
    const error = new BrazeServerSideError(payload.error_context, payload.message || payload.warn);
    error.name = payload.name || "GenericFetchError";
    throw error;
  }

  return payload;
}
